import React from 'react'
import NavLink from '../Routes/NavLink'

import CanvasComponent from '../Graphics/CanvasComponent.jsx'
import {floorPlanRenderer} from '../../core/graphic_engine/controllers/FloorPlanRenderer.js'
import THREE from 'particlespace-graphics-engine'

export default class FloorPlanCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updateCanvas: false,
            renderer: new THREE.CanvasRenderer(),
            canvasID: "floor-plan-card-holder",
            active: false
        }
    }

    componentDidMount() {
        floorPlanRenderer.createMini3DModel(this,this.props.floorData.step_size, this.props.floorData.grid_size, this.props.floorData.floor_plan_model);
    }

    componentWillUpdate(nextProps, nextState) {
    }

    onSelect() {
        this.setState({
            active: true
        });
    }

    render(){
        const floorData = this.props.floorData;
        var selected = this.state.active;
        var active = '';
        if(selected) {
            active = 'selected';
        }
        return (
            <div class={"col-md-4 floor-plan-card " + active} key={floorData.building_floor_plan_id} onClick={this.props.activateLayout.bind(this, floorData.building_floor_plan_id)}>
                <div class="card">
                    <div class="header">
                        <h4 class="title">{floorData.floor_plan_name}</h4>
                    </div>
                    <div class="content">
                        <CanvasComponent domID={this.state.canvasID} classID="ct-chart ct-perfect-fourth" renderer={this.state.renderer} updateCanvas={this.state.updateCanvas}/>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/FloorPlans/FloorPlanCard.jsx